@if (friend) {
  <div class="avatar">
    <app-avatar class="avatar-md w-24 flex-none mr-7"
                [url]="friend.avatar?.url ?? ''"
                [name]="friend.fullName"
    ></app-avatar>
  </div>
  <div class="user-info">
    <h3 class="name">{{ friend.fullName }}</h3>
    <p class="username"> {{ '@' + friend.userName }}</p>
  </div>
  <div class="actions">
    <div class="icon">
      <app-icon size="medium" *ngIf="friend.shareTo === 'active' && friend.shareFrom !== 'active'"
                name="arrowLeft"></app-icon>
      <app-icon size="medium" *ngIf="friend.shareFrom === 'active' && friend.shareTo !== 'active'"
                name="arrowRight"></app-icon>
      <app-icon size="medium" *ngIf="friend.shareFrom === 'active' && friend.shareTo === 'active'"
                name="arrowLeftRight"></app-icon>
    </div>
    <div class="more">
      <app-friends-action-menu (eventTriggered)="onEvent($event)" [friend]="friend"></app-friends-action-menu>
    </div>
  </div>
}
